import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3104, { U3104ROLES } from "./U3104";
import U3104AccountingYearList from "./components/U3104AccountingYearList";
import U3104AccountingYearForm from "./components/U3104AccountingYearForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3104Routes: RouteObject[] = [
  {
    path: "U3104",
    element: <U2000RequireRole allowedRoles={[U3104ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3104 />,
        children: [
          { index: true, element: <U3104AccountingYearList /> },
          { path: ":id", element: <U3104AccountingYearForm /> },
        ],
      },
    ],
  },
];

export default U3104Routes;
